/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'beatpulse-logout': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16.9 10.909H6.815a.909.909 0 0 1 0-1.818H16.9l-3.452-3.448a.91.91 0 1 1 1.286-1.286l5 5a.909.909 0 0 1 0 1.285l-5 5a.91.91 0 1 1-1.286-1.286zM10.909 0a.909.909 0 0 1 0 1.818H2.277a.457.457 0 0 0-.459.458v15.448a.457.457 0 0 0 .459.458h8.632a.909.909 0 0 1 0 1.818H2.277A2.276 2.276 0 0 1 0 17.724V2.276A2.275 2.275 0 0 1 2.277 0z" _fill="#f8690a"/>'
  }
})
